import { motion } from "framer-motion";
import { Check, X } from "lucide-react";

const COMPETITORS = ["Shine", "Henrri", "Obat", "Tolteck", "Sinao", "Zervant", "Sellsy", "Axonaut", "Evoliz", "Pennylane"];

// v = true (✓), false (✗) ou texte court
const ROWS = [
  { label: "Prix / mois", fx: "9 / 19 / 49 €", vals: ["0–29 €", "Gratuit", "29–49 €", "29–49 €", "12–39 €", "0–20 €", "39–99 €", "29–59 €", "19–49 €", "49–99 €"] },
  { label: "Factur-X", fx: true, vals: [true, true, false, true, false, true, false, true, true, true] },
  { label: "Extraction IA PDF", fx: true, vals: [false, false, false, false, false, false, false, false, "OCR", "OCR"] },
  { label: "UBL / CII", fx: true, vals: [false, false, false, false, false, false, false, false, false, false] },
  { label: "Envoi PDP", fx: true, vals: [true, false, false, false, false, false, false, false, true, true] },
  { label: "Cycle de vie (accepter/refuser)", fx: true, vals: [false, false, false, false, false, false, false, false, false, false] },
  { label: "Octroi de mer DOM-TOM", fx: true, vals: [false, false, false, false, false, false, false, false, false, false] },
  { label: "Archivage 10 ans", fx: true, vals: ["Limité", false, false, false, false, true, false, true, true, true] },
];

const Cell = ({ v, highlight }) => {
  if (v === true)
    return <Check data-testid={highlight ? "cmp-check-fx" : "cmp-check"} className={`h-5 w-5 mx-auto ${highlight ? "text-[#00D4FF]" : "text-[#34C759]"}`} />;
  if (v === false)
    return <X className="h-5 w-5 mx-auto text-zinc-600" />;
  return <span className={`font-mono text-xs ${highlight ? "text-[#00D4FF]" : "text-zinc-400"}`}>{v}</span>;
};

export default function ComparisonSection() {
  return (
    <section id="comparatif" className="max-w-7xl mx-auto px-6 md:px-10 pb-28 md:pb-40" data-testid="comparison-section">
      <motion.div
        initial={{ opacity: 0, y: 48 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="overline-label mb-4">Comparatif septembre 2026</p>
        <h2 className="font-display font-light tracking-tighter text-4xl md:text-5xl max-w-3xl leading-tight">
          FacturXpress <span className="text-[#00D4FF]">vs les autres.</span>
        </h2>
        <p className="mt-4 text-zinc-400 max-w-2xl text-base md:text-lg">
          Shine, Henrri, Obat, Tolteck, Sinao, Zervant, Sellsy, Axonaut, Evoliz, Pennylane :
          qui fait vraiment quoi ? Comparatif établi sur informations publiques.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        className="mt-14 rounded-2xl border border-white/10 bg-[#0A0E17] overflow-hidden"
      >
        <div className="overflow-x-auto" data-testid="comparison-scroll">
          <table className="w-full min-w-[980px] text-sm" data-testid="comparison-table">
            <thead>
              <tr className="border-b border-white/10">
                <th className="px-4 py-4 text-left overline-label sticky left-0 bg-[#0A0E17] min-w-[180px]">Critère</th>
                {COMPETITORS.map((c) => (
                  <th key={c} className="px-3 py-4 text-center font-mono text-[11px] uppercase tracking-wider text-zinc-500 min-w-[76px]">
                    {c}
                  </th>
                ))}
                <th className="px-3 py-4 text-center font-display text-xs text-[#00D4FF] bg-[#00283A] border-x border-[#00D4FF]/40 min-w-[110px]">
                  FacturXpress
                </th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row) => (
                <tr key={row.label} data-testid={`cmp-row-${row.label.slice(0, 12).replace(/\s/g, "-")}`} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02] transition-colors duration-150">
                  <td className="px-4 py-3.5 text-zinc-200 sticky left-0 bg-[#0A0E17]">{row.label}</td>
                  {row.vals.map((v, i) => (
                    <td key={i} className="px-3 py-3.5 text-center">
                      <Cell v={v} />
                    </td>
                  ))}
                  <td className="px-3 py-3.5 text-center bg-[#00283A]/60 border-x border-[#00D4FF]/40">
                    <Cell v={row.fx} highlight />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="px-4 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600 border-t border-white/5">
          Comparatif établi sur informations publiques — septembre 2026
        </p>
      </motion.div>
    </section>
  );
}
